<template>
  <div class="orders-view">
    <!-- Top bar -->
    <div class="nav-bar-operations">
      <img src="@/assets/logogruas.png" alt="HomePage" @click="backMainPanel" class="logo-button" />
    </div>
    <div class="top-spacer"></div>

    <!-- Header -->
    <div class="panel-head">
      <div class="head-left">
        <h3>Maestro de siniestros</h3>
      </div>
      <img src="@/assets/filtros.png" alt="filtros" class="head-icon"/>
    </div>

    <!-- Filters -->
    <form class="filters-card" @submit.prevent="queryOrders">
      <div class="row">
        <label for="incident_number">Número de incidente</label>
        <input id="incident_number" type="text" v-model="incidentNumber" placeholder="Ej: SIN-2048" />
        <div class="cell span-2"></div>
      </div>

      <div class="row">
        <label>Estatus</label>
        <div class="chips">
          <label class="chip" v-for="status in incidentStatuses" :key="status.id">
            <input type="checkbox" :value="status.id" v-model="selectedStatusIds" />
            <span>{{ status.status }}</span>
          </label>
        </div>
      </div>

      <div class="row">
        <label for="unit">Unidad</label>
        <input id="unit" type="text" v-model="unit" placeholder="# Económico" />
        <div class="cell span-2"></div>
      </div>

      <div class="row">
        <label>Fecha de solicitud</label>
        <input type="date" v-model="startDate" />
        <span class="sep">al</span>
        <input type="date" v-model="endDate" />
      </div>

      <div class="row">
        <label for="company">Compañía</label>
        <input id="company" type="text" v-model="company" placeholder="Ej: Filiales" />
        <div class="cell span-2"></div>
      </div>

      <div class="row">
        <label for="operator">Operador</label>
        <input id="operator" type="text" v-model="operator" placeholder="Nombre o ID" />
        <div class="cell span-2"></div>
      </div>

      <div class="row">
        <label for="repair_order">Orden de reparación</label>
        <input id="repair_order" type="text" v-model="repairOrderNumber" placeholder="Ej: OP-123" />
        <div class="cell span-2"></div>
      </div>

      <div class="row">
        <label for="accident_type">Tipo de accidente</label>
        <input id="accident_type" type="text" v-model="accidentType" placeholder="Ej: Colisión" />
        <div class="cell span-2"></div>
      </div>

      <div class="row">
        <label for="veredict">Veredicto</label>
        <input id="veredict" type="text" v-model="veredict" placeholder="Ej: Culpable" />
        <div class="cell span-2"></div>
      </div>

      <div class="row actions">
        <div class="cell span-4">
          <button type="submit" class="btn-primary">Aplicar filtros</button>
        </div>
      </div>
    </form>

    <!-- Results -->
    <section class="results-card" id="results-section">
      <div v-if="!canViewTable" class="no-access">
        No tienes permisos para ver el listado de siniestros.
      </div>
      <div class="results-head">
        <h2>Resultados: {{ totalCount }}</h2>
      </div>

      <div v-if="canViewTable" class="table-scroll">
        <table class="table">
          <thead>
            <tr>
              <th @click="toggleSort('incident_number')">
                Incidente
                <span v-if="isSorted('incident_number')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('status')">
                Estatus
                <span v-if="isSorted('status')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('unit')">
                Unidad
                <span v-if="isSorted('unit')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('request_time')">
                Solicitud
                <span v-if="isSorted('request_time')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('company')">
                Compañía
                <span v-if="isSorted('company')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('operator_employee_ident')">
                Operador
                <span v-if="isSorted('operator_employee_ident')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('repair_order_number')">
                Orden reparación
                <span v-if="isSorted('repair_order_number')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('accident_type')">
                Tipo accidente
                <span v-if="isSorted('accident_type')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
              <th @click="toggleSort('veredict')">
                Veredicto
                <span v-if="isSorted('veredict')">{{ sortState.dir === 'asc' ? '▲' : '▼' }}</span>
                <span v-else>↕</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="incident in queriedOrders" :key="incident.id" class="row-click" @click="viewIncident(incident.id)">
              <td>
                <span class="badge badge-id" @click.stop="viewIncident(incident.id)">
                  {{ incident.incident_number || incident.id }}
                </span>
              </td>
              <td>{{ incident.incident_status_label || incident.incident_status || 'N/A' }}</td>
              <td>{{ incident.unit_short_id || 'N/A' }}</td>
              <td>{{ formatDateTime(incident.request_time) }}</td>
              <td>{{ incident.company_name || incident.company || 'N/A' }}</td>
              <td>{{ incident.operator_full_name || incident.operator_employee_ident || incident.operator || 'N/A' }}</td>
              <td>{{ incident.repair_order_number || 'N/A' }}</td>
              <td>{{ incident.accident_type || 'N/A' }}</td>
              <td>{{ incident.veredict || 'N/A' }}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Pagination -->
      <div class="pagination">
        <button @click="prevPage" :disabled="currentPage === 1" class="pg-btn" aria-label="Página anterior">
          <img src="@/assets/angulo-izquierdo.png" alt="Previous Page" />
        </button>
        <span
          v-for="pageNumber in TotalPages"
          :key="pageNumber"
          @click="goToPage(pageNumber)"
          :class="['pg-num', { active: pageNumber === currentPage }]"
        >
          {{ pageNumber }}
        </span>
        <button @click="nextPage" :disabled="currentPage >= TotalPages" class="pg-btn" aria-label="Página siguiente">
          <img src="@/assets/angulo-derecho.png" alt="Next Page" />
        </button>
      </div>
    </section>
  </div>
</template>

<script>
import axios from 'axios'
import Swal from 'sweetalert2'

export default {
  name: 'UnitIncidentsFilters',
  data() {
    return {
      permissions: [],
      incidentNumber: '',
      unit: '',
      startDate: '',
      endDate: '',
      company: '',
      operator: '',
      repairOrderNumber: '',
      accidentType: '',
      veredict: '',
      incidentStatuses: [],
      selectedStatusIds: [],
      queriedOrders: [],
      currentPage: 1,
      pageSize: 20,
      totalCount: 0,
      sortState: { by: 'request_time', dir: 'desc' },
    }
  },
  computed: {
    canViewTable() {
      return this.hasAnyPerm(['maintenance.view_incident_table'])
    },
    canViewIncident() {
      return this.hasAnyPerm(['maintenance.view_incident'])
    },
    canAccessIncidentMaster() {
      return this.hasAnyPerm(['maintenance.view_incident_master'])
    },
    effectiveEndDate() {
      return this.endDate || this.startDate
    },
    TotalPages() {
      return Math.max(1, Math.ceil(this.totalCount / this.pageSize))
    },
  },
  mounted() {
    this.loadPermissions()
    if (!this.canAccessIncidentMaster) {
      Swal.fire('Sin acceso', 'No tienes permisos para ver el maestro de siniestros.', 'warning')
      this.$router.push({ name: 'MainPanel' })
      return
    }
    this.fetchIncidentStatuses()
  },
  methods: {
    loadPermissions() {
      try {
        this.permissions = JSON.parse(localStorage.getItem('userPermissions')) || []
      } catch (error) {
        this.permissions = []
      }
    },
    hasPerm(perm) {
      if (!perm) return false
      if (this.permissions.includes(perm)) return true
      return this.permissions.includes(`access_control.${perm}`)
    },
    hasAnyPerm(perms) {
      if (!Array.isArray(perms) || perms.length === 0) return false
      return perms.some((perm) => this.hasPerm(perm))
    },
    backMainPanel() {
      this.$router.push({ path: '/main-panel' })
    },
    viewIncident(incidentId) {
      if (!this.canViewIncident) {
        Swal.fire('Sin acceso', 'No tienes permisos para ver la incidencia.', 'warning')
        return
      }
      this.$router.push({ path: `/unit-incidents/${incidentId}` })
    },
    formatToDatetime(date, time) {
      return date ? `${date}T${time}` : ''
    },
    formatDateTime(value) {
      if (!value) return 'N/A'
      return `${value.substring(8, 10)}/${value.substring(5, 7)}/${value.substring(0, 4)} ${value.substring(11, 16)}`
    },
    orderingParam() {
      if (!this.sortState?.by) return ''
      const prefix = this.sortState.dir === 'desc' ? '-' : ''
      return `&ordering=${encodeURIComponent(prefix + this.sortState.by)}`
    },
    isSorted(field) {
      return this.sortState.by === field
    },
    toggleSort(field) {
      if (this.sortState.by === field) {
        this.sortState.dir = this.sortState.dir === 'asc' ? 'desc' : 'asc'
      } else {
        this.sortState.by = field
        this.sortState.dir = 'asc'
      }
      this.currentPage = 1
      this.queryOrders()
    },
    goToPage(pageNumber) {
      this.currentPage = pageNumber
      this.queryOrders()
    },
    nextPage() {
      if (this.currentPage < this.TotalPages) this.currentPage++
      this.queryOrders()
    },
    prevPage() {
      if (this.currentPage > 1) this.currentPage--
      this.queryOrders()
    },
    async fetchIncidentStatuses() {
      try {
        const apiDirectory = process.env.API_DIRECTORY
        const response = await axios.get(`${apiDirectory}/incident-statuses`)
        this.incidentStatuses = response.data || []
      } catch (error) {
        console.error('Error fetching incident statuses:', error)
      }
    },
    async queryOrders() {
      if (!this.canViewTable) {
        Swal.fire('Sin acceso', 'No tienes permisos para ver el listado de siniestros.', 'warning')
        return
      }
      const payload = {
        incident_number: this.incidentNumber,
        incident_status: this.selectedStatusIds,
        unit_short_id: this.unit,
        start_date: this.formatToDatetime(this.startDate, '00:00'),
        end_date: this.formatToDatetime(this.effectiveEndDate, '23:59'),
        company: this.company,
        operator: this.operator,
        repair_order_number: this.repairOrderNumber,
        accident_type: this.accidentType,
        veredict: this.veredict,
      }
      const orderingQS = this.orderingParam()
      try {
        const apiDirectory = process.env.API_DIRECTORY
        const url = `${apiDirectory}/get-unit-incidents-global-filtered?page=${this.currentPage}&page_size=${this.pageSize}${orderingQS}`
        const response = await axios.post(url, payload)
        this.queriedOrders = response.data.results || []
        this.totalCount = response.data.count || 0
        this.$nextTick(() => {
          const el = document.getElementById('results-section')
          if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        })
      } catch (error) {
        const errorMessage = error.response ? (error.response.data.error || JSON.stringify(error.response.data)) : error.message
        Swal.fire({ icon: 'error', title: 'Error Generando Reporte', text: errorMessage })
      }
    },
  },
}
</script>

<style scoped>
:root {
  --brand: #ffc434;
  --brand-600: #e6b12e;
  --bg: #f7f7f8;
  --card: #ffffff;
  --border: #e8e8ea;
  --muted: #70737a;
  --text: #1f2328;

  --radius-sm: 6px;
  --radius-md: 10px;
  --shadow-1: 0 1px 6px rgba(0,0,0,.06);
  --shadow-2: 0 4px 14px rgba(0,0,0,.08);
}

.orders-view {
  background: var(--bg);
  min-height: 100%;
}

.no-access{
  margin: 16px 0;
  padding: 12px;
  border-radius: 10px;
  border: 1px solid #f3c7c7;
  background: #fff3f3;
  color: #9b1c1c;
  font-weight: 700;
}

.nav-bar-operations {
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 56px;
  background: var(--brand);
  z-index: 1000;
  box-shadow: var(--shadow-1);
}
.logo-button {
  position: absolute; height: 80%;
  top: 50%; left: 50%;
  transform: translate(-50%, -50%);
  cursor: pointer; margin: 0;
}
.top-spacer { height: 56px; }

.panel-head {
  margin: 10px 10px 8px;
  padding: 6px 8px;
  display: flex; align-items: center; justify-content: space-between;
}
.panel-head h3 {
  margin: 0;
  font-size: 14px;
  color: var(--text);
  letter-spacing: .2px;
}
.head-icon { width: 22px; height: 22px; opacity: .9; }

.filters-card {
  margin: 0 10px 10px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: var(--shadow-1);
  padding: 8px;
  display: grid;
  grid-template-columns: 1fr;
  gap: 6px;
  font-size: 12px;
}
.filters-card .row {
  display: grid;
  grid-template-columns: 140px 320px 22px 320px;
  align-items: center;
  gap: 4px;
  min-height: 28px;
}
.filters-card .row.actions { grid-template-columns: 1fr; margin-top: 2px; }
.filters-card label {
  color: var(--text);
  font-size: 12px;
  white-space: nowrap;
}
.filters-card .sep {
  text-align: center;
  color: var(--muted);
  font-size: 11px;
}
.filters-card input[type="text"],
.filters-card input[type="date"],
.filters-card select {
  height: 26px;
  padding: 0 8px;
  border: 1px solid #d2d2d2;
  border-radius: var(--radius-sm);
  font-size: 12px;
  outline: none;
  background: #fff;
}
.filters-card input::placeholder { color: #9aa0a6; font-size: 11px; }
.filters-card input:focus,
.filters-card select:focus {
  border-color: #bbb;
  box-shadow: 0 0 0 2px rgba(255,196,52,.22);
}

.chips {
  grid-column: 2 / -1;
  display: flex; gap: 6px; flex-wrap: wrap;
}
.chip {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 4px 8px;
  border: 1px solid var(--border);
  border-radius: var(--radius-md);
  background: #fafafa;
  font-size: 11.5px;
  cursor: pointer;
  user-select: none;
}
.chip input { width: 14px; height: 14px; margin: 0; }
.chip input:checked + span { font-weight: 600; }

.btn-primary {
  padding: 6px 12px;
  font-size: 12px;
  border-radius: 8px;
  background: var(--brand);
  border: none; cursor: pointer;
  box-shadow: var(--shadow-1);
}
.btn-primary:hover { background: var(--brand-600); }

.results-card {
  margin: 0 10px 16px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 8px;
  box-shadow: var(--shadow-1);
  overflow: hidden;
}
.results-head {
  padding: 8px 10px;
  border-bottom: 1px solid var(--border);
}
.results-head h2 {
  font-size: 14px; margin: 0; color: var(--text);
}

.table-scroll { overflow-x: auto; }
.table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
  line-height: 1.15;
}
.table thead th {
  position: sticky; top: 0; z-index: 1;
  background: #f5f6f8;
  color: #475163;
  font-weight: 600;
  border-bottom: 1px solid var(--border);
  padding: 6px 8px;
  white-space: nowrap;
  cursor: pointer;
}
.table tbody td {
  padding: 5px 8px;
  border-bottom: 1px solid #f0f0f0;
  white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
}
.table tbody tr:nth-child(even) td { background: #fcfcfd; }
.table tbody tr:hover td { background: #eef3ff; color: #0f172a; }
.row-click { cursor: pointer; }

.badge {
  display: inline-block;
  padding: 2px 8px;
  border-radius: var(--radius-sm);
  font-size: 11px;
  line-height: 1.3;
  border: 1px solid transparent;
}
.badge-id {
  background: var(--brand);
  color: #000;
  font-weight: 700;
  border: 1px solid #f0c35a;
}

.pagination {
  display: flex; flex-wrap: wrap;
  justify-content: center; align-items: center;
  gap: 6px; padding: 10px;
  border-top: 1px solid var(--border);
}
.pg-btn {
  background: #fff; border: 1px solid var(--border);
  border-radius: 8px; padding: 2px 6px;
  cursor: pointer; box-shadow: var(--shadow-1);
}
.pg-btn:disabled { opacity: .5; cursor: not-allowed; }
.pg-btn img { width: 18px; height: auto; display: block; }
.pg-num {
  min-width: 28px; text-align: center;
  padding: 4px 8px; border-radius: 8px;
  border: 1px solid var(--border);
  background: #fff; cursor: pointer;
  user-select: none;
}
.pg-num.active {
  background: var(--brand);
  border-color: #e0b12b;
}

@media (max-width: 1200px) {
  .filters-card .row {
    grid-template-columns: 120px minmax(180px,1fr) 18px minmax(180px,1fr);
  }
}
@media (max-width: 900px) {
  .filters-card .row { grid-template-columns: 120px 1fr; }
  .filters-card .sep, .filters-card .row > .cell { display: none; }
}
</style>
